<!-- Modal (Chamadas Realizadas) -->

<ng-template #chamadasRealizadas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-chamadas-realizadas"><b>Chamadas Realizadas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th class="text-center">Número</th>
            <th class="text-center tabela_borda">Início</th>
            <th class="text-center tabela_borda">Fim</th>
            <th class="text-center tabela_borda">Duração</th>
          </tr>
        </thead>

        <tbody>
          @for (chamada of chamadas; track chamada) {
            <tr>
              <td class="text-center">{{ chamada.numero }}</td>
              <td class="text-center tabela_borda">{{ chamada.inicio | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td class="text-center tabela_borda">{{ chamada.fim | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td class="text-center tabela_borda">{{ chamada.duracao }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Pausas Realizadas) -->

<ng-template #pausasRealizadas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-pausas-realizadas"><b>Pausas Realizadas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Vendedor(a):</b></label>

        <input class="form-control form-control-sm" type="text" name="vendedor" [value]="pausasSelecionadas.length > 0 ? pausasSelecionadas[0].fullname : ''" disabled />
      </div>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Motivo</th>
            <th class="text-center tabela_borda">Data</th>
            <th class="text-center tabela_borda">Tempo</th>
            <th class="text-center tabela_borda">Hr. Inicial</th>
            <th class="text-center tabela_borda">Hr. Final</th>
          </tr>
        </thead>

        <tbody>
          @for (pausaSelecionada of pausasSelecionadas; track pausaSelecionada) {
            <tr>
              <td>{{ pausaSelecionada.nome }}</td>
              <td class="text-center tabela_borda">{{ pausaSelecionada.data_criacao_usuario | date: 'dd/MM/yyyy' }}</td>
              <td class="text-center tabela_borda">{{ pausaSelecionada.tempo_pausa }}</td>
              <td class="text-center tabela_borda">{{ pausaSelecionada.hr_inicial_pausa }}</td>
              <td class="text-center tabela_borda">{{ pausaSelecionada.hr_final_pausa }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="titulo_texto">Dashboard - Call Center</div>
    </div>
    <!-- Filtro -->
    <div class="pt-3 pr-4 pb-0 pl-4">
      <form [formGroup]="formFiltro" (ngSubmit)="filtrar()">
        <div class="form-row">
          <!-- Período -->
          <div class="form-group col-sm-2">
            <label class="text-secondary"><b>Dt. Inicial:</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_dt_inicial" ngbDatepicker #dt_inicial="ngbDatepicker" (click)="dt_inicial.toggle()" formControlName="dt_inicial" />
          </div>
          <div class="form-group col-sm-2">
            <label class="text-secondary"><b>Dt. Final:</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_dt_final" ngbDatepicker #dt_final="ngbDatepicker" (click)="dt_final.toggle()" formControlName="dt_final" />
          </div>
          <!-- Resultado -->
          <div class="form-group col-sm-3">
            <label class="text-secondary"><b>Resultado:</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_resultado" formControlName="resultado" />
          </div>
          <!-- Equipe/Vendedor(a) -->
          <div class="form-group col-sm-3">
            <label class="text-secondary"><b>Equipe/Vendedor(a):</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_vendedor" formControlName="vendedor" />
          </div>
          <div class="col-sm-2">
            <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>
            @if (filtrado) {
              <button class="btn btn-secondary btn_filtro" type="button" (click)="removerFiltros()">Cancelar</button>
            }
          </div>
        </div>
      </form>
      <hr class="mt-2 mb-2" />
    </div>
    <div class="pt-2 pr-4 pb-4 pl-4">
      <div class="d-flex flex-wrap align-content-center justify-content-center">
        <!-- Agendado -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-phone quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ qtdeTotalAgendado + "/" + qtdeTotalAgendadoRealizado }}<br />Agendado
            </div>
            <div class="quadros_numeros_porcentagem">
              {{ porcentagemQtdeTotalAgendadoRealizado | currency: 'BRL' : '' }}%
            </div>
          </div>
        </div>
        <!-- Gerado -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-phone quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ qtdeTotalGerado + "/" + qtdeTotalGeradoRealizado }}<br />Gerado
            </div>
            <div class="quadros_numeros_porcentagem">
              {{ porcentagemQtdeTotalGeradoRealizado | currency: 'BRL' : '' }}%
            </div>
          </div>
        </div>
        <!-- Manual -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-phone quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ qtdeTotalManual }}<br />Manual
            </div>
          </div>
        </div>
        <!-- Realizado (Total) -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-phone quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ qtdeTotalRealizado }}<br />Realizado (Total)
            </div>
            <div class="quadros_numeros_porcentagem">
              {{ porcentagemQtdeTotalRealizado | currency: 'BRL' : '' }}%
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap align-content-center justify-content-center">
        <!-- Venda Realizada -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-check quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ qtdeVendaRealizada }}<br />Venda Realizada
            </div>
            <div class="quadros_numeros_porcentagem">
              {{ porcentagemQtdeVendaRealizada | currency: 'BRL' : '' }}%
            </div>
          </div>
        </div>
        <!-- Não Comprou -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-thumbs-down quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ qtdeNaoComprou }}<br />Não Comprou
            </div>
            <div class="quadros_numeros_porcentagem">
              {{ porcentagemQtdeNaoComprou | currency: 'BRL' : '' }}%
            </div>
          </div>
        </div>
        <!-- Total Pausas -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-pause quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ qtdePausa }}<br />Pausa
            </div>
          </div>
        </div>
        <!-- Tempo Médio por Ligação -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-clock-o quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ tempoMedioPorLigacao }}<br />Tempo Médio por Ligação
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <div class="d-flex flex-wrap justify-content-between">
        <!-- Gráfico de Efetividade -->
        <div class="flex-grow-1 grafico_efetividade p-2">
          <div class="text-center pb-2">
            <b>Gráfico de Efetividade</b>
          </div>
          <div style="display: block;">
            <canvas baseChart
              [datasets]="lineChartDataEfetividade"
              [labels]="lineChartLabelsEfetividade"
              [options]="lineChartOptionsEfetividade"
              [plugins]="lineChartPluginsEfetividade"
              [legend]="lineChartLegendEfetividade"
              [chartType]="lineChartTypeEfetividade"
              [colors]="lineChartColorsEfetividade"
              height="120">
            </canvas>
          </div>
        </div>
        <!-- Gráfico de Ligações por Tipo -->
        <div class="flex-grow-1 grafico_ligacoes p-2">
          <div class="text-center pb-2">
            <b>Gráfico de Ligações por Tipo</b>
          </div>
          <div style="display: block;">
            <canvas baseChart
              [datasets]="barChartDataLigacoes"
              [labels]="barChartLabelsLigacoes"
              [options]="barChartOptionsLigacoes"
              [plugins]="barChartPluginsLigacoes"
              [legend]="barChartLegendLigacoes"
              [chartType]="barChartTypeLigacoes"
              [colors]="lineChartColorsLigacoes"
              height="250">
            </canvas>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <!-- Detalhamento dos Resultados / Detalhamento dos Pedidos (6 Meses) -->
      <div class="d-flex flex-wrap justify-content-between">
        <div class="detalhamento_resultados flex-grow-1">
          <div class="text-center p-2">
            <b>Detalhamento dos Resultados</b>
          </div>
          <div class="p-2">
            <div class="table-responsive">
              <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th>Resultado</th>
                      <th class="text-right tabela_borda">%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *cdkVirtualFor="let resultadoAgrupado of resultadosAgrupados; let i = index; templateCacheSize: 0;">
                      <td>{{ resultadosAgrupados[i].key }}</td>
                      <td class="text-right tabela_borda">{{ resultadosAgrupados[i].value.length }}</td>
                    </tr>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </div>
        <div class="detalhamento_pedidos flex-grow-1">
          <div class="text-center p-2">
            <b>Detalhamento dos Pedidos (120 Dias)</b>
          </div>
          <div class="p-2">
            <div class="table-responsive">
              <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th>Vendedor Externo</th>
                      <th class="text-right tabela_borda">Vendas: R$</th>
                      <th class="text-right tabela_borda">Litragem</th>
                      <th class="text-right tabela_borda">Externo: R$</th>
                      <th class="text-right">%</th>
                      <th class="text-right tabela_borda">Interno: R$</th>
                      <th class="text-right">%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *cdkVirtualFor="let pedidoAgrupado of pedidosAgrupados; templateCacheSize: 0;">
                      <td>{{ pedidoAgrupado.vendedor }}</td>
                      <td class="text-right tabela_borda">{{ pedidoAgrupado.vendas_total | currency: 'BRL' }}</td>
                      <td class="text-right tabela_borda">{{ pedidoAgrupado.litragem_total | currency: 'BRL' : '' }}</td>
                      <td class="text-right tabela_borda">{{ pedidoAgrupado.vendas_externas | currency: 'BRL' }}</td>
                      <td class="text-center">
                        @if (pedidoAgrupado.porcentagem_vendas_externas < 30) {
                          <span class="badge badge-danger">{{ pedidoAgrupado.porcentagem_vendas_externas | currency: 'BRL' : '' }}%</span>
                        }
                        @if (pedidoAgrupado.porcentagem_vendas_externas >= 30 && pedidoAgrupado.porcentagem_vendas_externas <= 70) {
                          <span class="badge badge-warning">{{ pedidoAgrupado.porcentagem_vendas_externas | currency: 'BRL' : '' }}%</span>
                        }
                        @if (pedidoAgrupado.porcentagem_vendas_externas > 70) {
                          <span class="badge badge-success">{{ pedidoAgrupado.porcentagem_vendas_externas | currency: 'BRL' : '' }}%</span>
                        }
                      </td>
                      <td class="text-right tabela_borda">{{ pedidoAgrupado.vendas_internas | currency: 'BRL' }}</td>
                      <td class="text-center">
                        @if (pedidoAgrupado.porcentagem_vendas_internas < 30) {
                          <span class="badge badge-danger">{{ pedidoAgrupado.porcentagem_vendas_internas | currency: 'BRL' : '' }}%</span>
                        }
                        @if (pedidoAgrupado.porcentagem_vendas_internas >= 30 && pedidoAgrupado.porcentagem_vendas_internas <= 70) {
                          <span class="badge badge-warning">{{ pedidoAgrupado.porcentagem_vendas_internas | currency: 'BRL' : '' }}%</span>
                        }
                        @if (pedidoAgrupado.porcentagem_vendas_internas > 70) {
                          <span class="badge badge-success">{{ pedidoAgrupado.porcentagem_vendas_internas | currency: 'BRL' : '' }}%</span>
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <!-- Relatório Sintético por Equipe -->
      <div class="d-flex flex-wrap justify-content-between">
        <div class="relatorio_sintetico_equipe flex-grow-1">
          <div class="text-center p-2">
            <b>Relatório Sintético por Equipe</b>
          </div>
          <div class="p-2">
            <div class="table-responsive">
              <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th colspan="2"></th>
                      <th class="text-center tabela_borda" colspan="3">Agendado</th>
                      <th class="text-center tabela_borda" colspan="3">Gerado</th>
                      <th class="text-center tabela_borda">Manual</th>
                      <th class="text-center tabela_borda" colspan="2">Total</th>
                      <th class="text-center tabela_borda" colspan="4">Resultado</th>
                      <th class="text-center tabela_borda" colspan="2">Vendas</th>
                      <th class="text-center tabela_borda" colspan="8">Ligações</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th class="tabela_borda">Vendedor(a)</th>
                      <th class="text-center tabela_borda">Qtde</th>
                      <th class="text-center tabela_borda">Realizado</th>
                      <th class="text-right tabela_borda">%</th>
                      <th class="text-center tabela_borda">Qtde</th>
                      <th class="text-center tabela_borda">Realizado</th>
                      <th class="text-right tabela_borda">%</th>
                      <th class="text-center tabela_borda">Qtde</th>
                      <th class="text-center tabela_borda bg_tabela_secondary">Realizado</th>
                      <th class="text-center tabela_borda bg_tabela_secondary">Pausas</th>
                      <th class="text-center tabela_borda bg_tabela_success">Venda Realizada</th>
                      <th class="text-right tabela_borda bg_tabela_success">%</th>
                      <th class="text-center tabela_borda bg_tabela_danger">Não Comprou</th>
                      <th class="text-right tabela_borda bg_tabela_danger">%</th>
                      <th class="text-right tabela_borda bg_tabela_info">Valor</th>
                      <th class="text-right tabela_borda bg_tabela_info">Litragem</th>
                      <th class="text-center tabela_borda">E-mail</th>
                      <th class="text-right">%</th>
                      <th class="text-center tabela_borda">Feitas</th>
                      <th class="text-right">%</th>
                      <th class="text-center tabela_borda">Recebidas</th>
                      <th class="text-right">%</th>
                      <th class="text-center tabela_borda">WhatsApp</th>
                      <th class="text-right">%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *cdkVirtualFor="let ligacaoAgrupadasPorEquipe of ligacoesAgrupadasPorEquipe; templateCacheSize: 0;">
                      <td class="text-center tabela_acao">
                        @if (ligacaoAgrupadasPorEquipe.qtde_pausa> 0) {
                          <i class="fa fa-info btn_tabela_acao" placement="right" ngbTooltip="Pausas Realizadas" (click)="modalPausasRealizadas(pausasRealizadas, ligacaoAgrupadasPorEquipe.id_tmk)"></i>
                        }
                      </td>
                      <td class="tabela_borda"><b>{{ ligacaoAgrupadasPorEquipe.equipe }}</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadasPorEquipe.qtde_total_agendado }}</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadasPorEquipe.qtde_realizado_agendado }}</b></td>
                      <td class="text-right tabela_borda"><b>{{ ligacaoAgrupadasPorEquipe.porcentam_realizado_agendado | currency: 'BRL' : '' }}%</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadasPorEquipe.qtde_total_gerado }}</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadasPorEquipe.qtde_realizado_gerado }}</b></td>
                      <td class="text-right tabela_borda"><b>{{ ligacaoAgrupadasPorEquipe.porcentam_realizado_gerado | currency: 'BRL' : '' }}%</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadasPorEquipe.qtde_total_manual }}</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadasPorEquipe.qtde_total_realizado }}</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadasPorEquipe.qtde_total_pausa }}</b></td>
                      <td class="text-center tabela_borda bg_tabela_success"><b>{{ ligacaoAgrupadasPorEquipe.qtde_venda_realizada }}</b></td>
                      <td class="text-right tabela_borda bg_tabela_success"><b>{{ ligacaoAgrupadasPorEquipe.porcentagem_qtde_venda_realizada | currency: 'BRL' : '' }}%</b></td>
                      <td class="text-center tabela_borda bg_tabela_danger"><b>{{ ligacaoAgrupadasPorEquipe.qtde_nao_comprou }}</b></td>
                      <td class="text-right tabela_borda bg_tabela_danger"><b>{{ ligacaoAgrupadasPorEquipe.porcentagem_qtde_nao_comprou | currency: 'BRL' : '' }}%</b></td>
                      <td class="text-right tabela_borda bg_tabela_info"><b>{{ ligacaoAgrupadasPorEquipe.vendas_total | currency: 'BRL' }}</b></td>
                      <td class="text-right tabela_borda bg_tabela_info"><b>{{ ligacaoAgrupadasPorEquipe.litragem_total | currency: 'BRL' : '' }}</b></td>
                      <td class="text-center tabela_borda">{{ ligacaoAgrupadasPorEquipe.qtde_email }}</td>
                      <td class="text-right">{{ ligacaoAgrupadasPorEquipe.porcentagem_qtde_email | currency: 'BRL' : '' }}%</td>
                      <td class="text-center tabela_borda">{{ ligacaoAgrupadasPorEquipe.qtde_feitas }}</td>
                      <td class="text-right">{{ ligacaoAgrupadasPorEquipe.porcentagem_feitas | currency: 'BRL' : '' }}%</td>
                      <td class="text-center tabela_borda">{{ ligacaoAgrupadasPorEquipe.qtde_recebidas }}</td>
                      <td class="text-right">{{ ligacaoAgrupadasPorEquipe.porcentagem_recebidas | currency: 'BRL' : '' }}%</td>
                      <td class="text-center tabela_borda">{{ ligacaoAgrupadasPorEquipe.qtde_whatsapp }}</td>
                      <td class="text-right">{{ ligacaoAgrupadasPorEquipe.porcentagem_whatsapp | currency: 'BRL' : '' }}%</td>
                    </tr>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
          <div class="col-sm-12 text-right p-2">
            <button class="btn btn-link" type="button" (click)="exportarRelatorioSinteticoPorEquipe()">Exportar p/ Excel</button>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <!-- Relatório Sintético por Vendedor(a) -->
      <div class="d-flex flex-wrap justify-content-between">
        <div class="relatorio_sintetico_vendedor flex-grow-1">
          <div class="text-center p-2">
            <b>Relatório Sintético por Vendedor(a)</b>
          </div>
          <div class="p-2">
            <div class="table-responsive">
              <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th colspan="2"></th>
                      <th class="text-center tabela_borda" colspan="3">Agendado</th>
                      <th class="text-center tabela_borda" colspan="3">Gerado</th>
                      <th class="text-center tabela_borda">Manual</th>
                      <th class="text-center tabela_borda" colspan="2">Total</th>
                      <th class="text-center tabela_borda" colspan="4">Resultado</th>
                      <th class="text-center tabela_borda" colspan="2">Vendas</th>
                      <th class="text-center tabela_borda" colspan="8">Ligações</th>
                    </tr>
                    <tr>
                      <th>Vendedor(a)</th>
                      <th class="tabela_borda">Equipe</th>
                      <th class="text-center tabela_borda">Qtde</th>
                      <th class="text-center tabela_borda">Realizado</th>
                      <th class="text-right tabela_borda">%</th>
                      <th class="text-center tabela_borda">Qtde</th>
                      <th class="text-center tabela_borda">Realizado</th>
                      <th class="text-right tabela_borda">%</th>
                      <th class="text-center tabela_borda">Qtde</th>
                      <th class="text-center tabela_borda bg_tabela_secondary">Realizado</th>
                      <th class="text-center tabela_borda bg_tabela_secondary">Pausas</th>
                      <th class="text-center tabela_borda bg_tabela_success">Venda Realizada</th>
                      <th class="text-right tabela_borda bg_tabela_success">%</th>
                      <th class="text-center tabela_borda bg_tabela_danger">Não Comprou</th>
                      <th class="text-right tabela_borda bg_tabela_danger">%</th>
                      <th class="text-right tabela_borda bg_tabela_info">Valor</th>
                      <th class="text-right tabela_borda bg_tabela_info">Litragem</th>
                      <th class="text-center tabela_borda">E-mail</th>
                      <th class="text-right">%</th>
                      <th class="text-center tabela_borda">Feitas</th>
                      <th class="text-right">%</th>
                      <th class="text-center tabela_borda">Recebidas</th>
                      <th class="text-right">%</th>
                      <th class="text-center tabela_borda">WhatsApp</th>
                      <th class="text-right">%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *cdkVirtualFor="let ligacaoAgrupadaPorVendedor of ligacoesAgrupadasPorVendedor; templateCacheSize: 0;">
                      <td><b>{{ ligacaoAgrupadaPorVendedor.vendedor }}</b></td>
                      <td class="tabela_borda"><b>{{ ligacaoAgrupadaPorVendedor.equipe }}</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadaPorVendedor.qtde_total_agendado }}</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadaPorVendedor.qtde_realizado_agendado }}</b></td>
                      <td class="text-right tabela_borda"><b>{{ ligacaoAgrupadaPorVendedor.porcentam_realizado_agendado | currency: 'BRL' : '' }}%</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadaPorVendedor.qtde_total_gerado }}</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadaPorVendedor.qtde_realizado_gerado }}</b></td>
                      <td class="text-right tabela_borda"><b>{{ ligacaoAgrupadaPorVendedor.porcentam_realizado_gerado | currency: 'BRL' : '' }}%</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadaPorVendedor.qtde_total_manual }}</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadaPorVendedor.qtde_total_realizado }}</b></td>
                      <td class="text-center tabela_borda"><b>{{ ligacaoAgrupadaPorVendedor.qtde_total_pausa }}</b></td>
                      <td class="text-center tabela_borda bg_tabela_success"><b>{{ ligacaoAgrupadaPorVendedor.qtde_venda_realizada }}</b></td>
                      <td class="text-right tabela_borda bg_tabela_success"><b>{{ ligacaoAgrupadaPorVendedor.porcentagem_qtde_venda_realizada | currency: 'BRL' : '' }}%</b></td>
                      <td class="text-center tabela_borda bg_tabela_danger"><b>{{ ligacaoAgrupadaPorVendedor.qtde_nao_comprou }}</b></td>
                      <td class="text-right tabela_borda bg_tabela_danger"><b>{{ ligacaoAgrupadaPorVendedor.porcentagem_qtde_nao_comprou | currency: 'BRL' : '' }}%</b></td>
                      <td class="text-right tabela_borda bg_tabela_info"><b>{{ ligacaoAgrupadaPorVendedor.vendas_total | currency: 'BRL' }}</b></td>
                      <td class="text-right tabela_borda bg_tabela_info"><b>{{ ligacaoAgrupadaPorVendedor.litragem_total | currency: 'BRL' : '' }}</b></td>
                      <td class="text-center tabela_borda">{{ ligacaoAgrupadaPorVendedor.qtde_email }}</td>
                      <td class="text-right">{{ ligacaoAgrupadaPorVendedor.porcentagem_qtde_email | currency: 'BRL' : '' }}%</td>
                      <td class="text-center tabela_borda">{{ ligacaoAgrupadaPorVendedor.qtde_feitas }}</td>
                      <td class="text-right">{{ ligacaoAgrupadaPorVendedor.porcentagem_feitas | currency: 'BRL' : '' }}%</td>
                      <td class="text-center tabela_borda">{{ ligacaoAgrupadaPorVendedor.qtde_recebidas }}</td>
                      <td class="text-right">{{ ligacaoAgrupadaPorVendedor.porcentagem_recebidas | currency: 'BRL' : '' }}%</td>
                      <td class="text-center tabela_borda">{{ ligacaoAgrupadaPorVendedor.qtde_whatsapp }}</td>
                      <td class="text-right">{{ ligacaoAgrupadaPorVendedor.porcentagem_whatsapp | currency: 'BRL' : '' }}%</td>
                    </tr>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
          <div class="col-sm-12 text-right p-2">
            <button class="btn btn-link" type="button" (click)="exportarRelatorioSinteticoPorVendedor()">Exportar p/ Excel</button>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <!-- Acompanhamento das Ligações -->
      <div class="d-flex flex-wrap justify-content-between">
        <div class="acompanhamento_ligacoes flex-grow-1">
          <div class="text-center p-2">
            <b>Acompanhamento das Ligações</b>
          </div>
          <div class="p-2">
            <div class="table-responsive">
              <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th class="tabela_borda">Vendedor(a)</th>
                      <th class="text-center tabela_borda">Tipo</th>
                      <th class="text-center tabela_borda">Status</th>
                      <th class="text-center tabela_borda">Dt. Ligação</th>
                      <th class="text-center tabela_borda">Código</th>
                      <th class="tabela_borda">Cliente</th>
                      <th class="text-center tabela_borda">Check-in</th>
                      <th class="text-center">Check-out</th>
                      <th class="text-center">Duração</th>
                      <th class="text-center">Em Chamada</th>
                      <th class="tabela_borda">Resultado</th>
                      <th class="text-center tabela_borda">Agendamento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *cdkVirtualFor="let visitaComCheckIn of visitasComCheckIn; templateCacheSize: 0;">
                      <tr>
                        <td class="text-center tabela_acao">
                          @if (visitaComCheckIn.em_chamada != null) {
                            <i class="fa fa-info btn_tabela_acao" placement="right" ngbTooltip="Chamadas Realizadas" (click)="modalChamadasRealizadas(chamadasRealizadas, visitaComCheckIn.idcallcenterligacoes)"></i>
                          }
                        </td>
                        <td class="tabela_borda">{{ visitaComCheckIn.nome_equipe }}</td>
                        <td class="tabela_borda">
                          @if (visitaComCheckIn.tipo == 'E') {
                            <span class="badge badge-primary">E</span>
                          }
                          @if (visitaComCheckIn.tipo == 'F') {
                            <span class="badge badge-success">F</span>
                          }
                          @if (visitaComCheckIn.tipo == 'R') {
                            <span class="badge badge-warning">R</span>
                          }
                          @if (visitaComCheckIn.tipo == 'W') {
                            <span class="badge badge-info">W</span>
                          }
                        </td>
                        <td class="tabela_borda">
                          @if (visitaComCheckIn.statusnome == 'À Ligar') {
                            <span class="badge badge-primary">À Ligar</span>
                          }
                          @if (visitaComCheckIn.statusnome == 'Agendada') {
                            <span class="badge badge-warning">Agendada</span>
                          }
                          @if (visitaComCheckIn.statusnome == 'Não Comprou') {
                            <span class="badge badge-danger">Não Comprou</span>
                          }
                          @if (visitaComCheckIn.statusnome == 'Sem Contato') {
                            <span class="badge badge-secondary">Sem Contato</span>
                          }
                          @if (visitaComCheckIn.statusnome == 'Retornar (Não Estava)') {
                            <span class="badge badge-other">Retornar (Não Estava)</span>
                          }
                          @if (visitaComCheckIn.statusnome == 'Retornar (Proposta)') {
                            <span class="badge badge-info">Retornar (Proposta)</span>
                          }
                          @if (visitaComCheckIn.statusnome == 'Venda Realizada') {
                            <span class="badge badge-success">Venda Realizada</span>
                          }
                        </td>
                        <td class="text-center tabela_borda">{{ visitaComCheckIn.data_ligacao | date: 'dd/MM/yyyy' }}</td>
                        <td class="text-center tabela_borda"><b>{{ visitaComCheckIn.codigo_no_erp_do_cliente }}</b></td>
                        <td class="tabela_borda"><b>{{ visitaComCheckIn.cliente }}</b></td>
                        <td class="text-center tabela_borda">{{ visitaComCheckIn.check_in | date: 'HH:mm:ss' }}</td>
                        <td class="text-center">{{ visitaComCheckIn.check_out | date: 'HH:mm:ss' }}</td>
                        <td class="text-center">{{ visitaComCheckIn.duracao }} @if (visitaComCheckIn.duracao != null) {
                          <span>Min</span>
                        }</td>
                        <td class="text-center">{{ visitaComCheckIn.em_chamada }}</td>
                        <td class="tabela_borda">{{ visitaComCheckIn.resultado }}</td>
                        <td class="text-center tabela_borda">{{ visitaComCheckIn.data_proximo_agendamento | date: 'dd/MM/yyyy' }}</td>
                      </tr>
                      @if (visitaComCheckIn.note != null && visitaComCheckIn.note != '') {
                        <tr>
                          <td colspan="5"></td>
                          <td class="tabela_borda" colspan="8">{{ visitaComCheckIn.note }}</td>
                        </tr>
                      }
                    </ng-container>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
          <div class="col-sm-12 text-right p-2">
            <button class="btn btn-link" type="button" (click)="exportarAcompanhamento()">Exportar p/ Excel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
